<template>
  <div class="header-container">
    <div class="goods-title">
          <div class="big-title">{{title}}</div>
          <div class="big-title-text">{{English}}</div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'title-home',
  props: {
    title: {
      type: String,
      default: '商城精选'
    },
    English: {
      type: String,
      default: 'Shopping Mall Select'
    }
  }
}
</script>

<style scoped lang="scss">
  .goods-title {
    text-align: center;

    .big-title {
      font-weight: 800;
      font-size: var(--font-size-default-big);
      color: #00112B;
      line-height: 53px;
      margin-bottom: 5px;
    }

    .big-title-text {
      font-weight: 500;
      font-size: var(--font-size-default-16);
      color: #5F616C;
    }

  }
</style> 